export const qualityUris = {
  root: "quality",
  evaluations: "evaluations",
  validations: "validations",
  validation: "validations/:id",
  scorecards: "scorecards",
  scorecard: "scorecards/:id",
  createScorecard: "scorecards/new",
  editScorecard: "scorecards/:id/edit",
};
